export default Object.freeze({
    FEMENINO: 'F',
    MASCULINO: 'M'
})
